import { useState } from "react";

const photoLocations = [
  { name: "CVS Pharmacy — Chiefland", address: "1215 N Young Blvd, Chiefland, FL 32626", hours: "Mon–Sat 8 AM – 9 PM, Sun 9 AM – 7 PM", website: "https://www.cvs.com/" },
  { name: "Walgreens — Chiefland", address: "1305 N Young Blvd, Chiefland, FL 32626", hours: "Mon–Sun 8 AM – 10 PM", website: "https://www.walgreens.com/" },
  { name: "CVS Pharmacy — Gainesville", address: "1702 NW 13th St, Gainesville, FL 32609", hours: "Mon–Sat 8 AM – 9 PM, Sun 9 AM – 7 PM", website: "https://www.cvs.com/" },
  { name: "Walgreens — Gainesville", address: "1220 W University Ave, Gainesville, FL 32601", hours: "Mon–Sun 7 AM – 11 PM", website: "https://www.walgreens.com/" },
  { name: "The UPS Store — Gainesville", address: "3832 W Newberry Rd, Gainesville, FL 32607", hours: "Mon–Fri 8:30 AM – 7 PM, Sat 9 AM – 4 PM", website: "https://www.theupsstore.com/" },
  { name: "CVS Pharmacy — Archer Rd", address: "4110 SW Archer Rd, Gainesville, FL 32608", hours: "Mon–Sat 8 AM – 9 PM, Sun 9 AM – 7 PM", website: "https://www.cvs.com/" },
];

const dmvLocations = [
  {
    name: "Levy County Tax Collector — Bronson",
    address: "355 S Court St, Bronson, FL 32621",
    hours: "Mon–Fri, 8:30 AM – 4:30 PM",
    note: "Driver licenses, REAL ID, titles & registration. Appointment recommended.",
    featured: true,
  },
  {
    name: "Alachua County Tax Collector — Gainesville",
    address: "12 SE 1st St, Gainesville, FL 32601",
    hours: "Mon–Fri, 8:00 AM – 5:00 PM",
    note: "Nearest full-service DMV option. Appointment recommended.",
    featured: false,
  },
  {
    name: "Alachua County Tax Collector — West Gainesville",
    address: "5801 NW 34th Blvd, Gainesville, FL 32653",
    hours: "Mon–Fri, 8:00 AM – 5:00 PM",
    note: "West Gainesville option. Call ahead for current wait times.",
    featured: false,
  },
];

export default function CedarKeyHelpfulResourcesSection() {
  const [photoExpanded, setPhotoExpanded] = useState(false);
  const visiblePhotos = photoExpanded ? photoLocations : photoLocations.slice(0, 6);

  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Resources for Cedar Key Travelers
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Getting your passport ready involves more than just the application. Here are local resources to help you gather everything you need.
          </p>
        </div>

        <div className="space-y-6">

          {/* Passport Photos */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-camera-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Passport Photos</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Passport Photo Locations Near Cedar Key</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-2">
                Your passport application requires two identical 2&quot;×2&quot; passport photos taken within the last 6 months. Popular passport photo locations near Cedar Key include:
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
                {visiblePhotos.map((loc, i) => (
                  <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-3.5">
                    {loc.website ? (
                      <a href={loc.website} target="_blank" rel="noopener noreferrer" className="font-bold text-[#1A365D] text-xs leading-snug mb-1 block hover:text-[#F6C344] transition-colors">
                        {loc.name} <i className="ri-external-link-line text-[10px] ml-0.5"></i>
                      </a>
                    ) : (
                      <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{loc.name}</p>
                    )}
                    {loc.website ? (
                      <a href={loc.website} target="_blank" rel="noopener noreferrer" className="text-gray-500 text-xs leading-relaxed hover:text-[#1A365D] transition-colors block">
                        {loc.address}
                      </a>
                    ) : (
                      <p className="text-gray-500 text-xs leading-relaxed">{loc.address}</p>
                    )}
                    <p className="text-gray-400 text-xs mt-1">{loc.hours}</p>
                  </div>
                ))}
              </div>
              {!photoExpanded && photoLocations.length > 6 && (
                <button
                  onClick={() => setPhotoExpanded(true)}
                  className="text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs flex items-center gap-1.5 mb-4 cursor-pointer transition-colors"
                >
                  <i className="ri-add-circle-line text-sm"></i>
                  Show all {photoLocations.length} photo locations
                </button>
              )}
              <div className="flex flex-wrap gap-4 mb-4">
                <a href="https://travel.state.gov/content/travel/en/passports/how-apply/photos.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors">
                  <i className="ri-external-link-line text-sm"></i>U.S. State Dept. Official Photo Requirements
                </a>
              </div>
              <div className="bg-[#F7F8FA] border border-gray-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-lightbulb-line text-[#F6C344] mr-1.5"></i>
                  <strong>Tip:</strong> Wear a plain white or off-white top, no glasses, neutral expression. Photos must meet strict U.S. State Department specifications — ask the technician to confirm compliance before you leave.
                </p>
              </div>
            </div>
          </div>

          {/* Vital Records */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-file-text-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Vital Records</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Birth, Death, Marriage &amp; Divorce Records — Levy County</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">
                If you need a certified copy of your birth certificate for a passport application, a marriage certificate for a name change, or a divorce decree to support your passport correction, here are the official sources for vital records in Levy County. Most records can be ordered online for delivery within 5–10 business days.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                {[
                  { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Florida Department of Health in Levy County. Online, mail, or in-person options available.", url: "https://levy.floridahealth.gov/" },
                  { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through the Florida Department of Health in Levy County. Required for estate and legal matters.", url: "https://levy.floridahealth.gov/" },
                  { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Levy County Clerk of Courts. Certified copies available for name changes and legal purposes.", url: "https://www.levyclerk.org/" },
                  { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Levy County Clerk of Courts. Required for name change passport corrections and legal documentation.", url: "https://www.levyclerk.org/" },
                ].map((record, i) => (
                  <a
                    key={i}
                    href={record.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-3.5 bg-[#F7F8FA] border border-gray-200 rounded-lg p-4 hover:border-[#F6C344] transition-all group"
                  >
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0 mt-0.5">
                      <i className={`${record.icon} text-[#1A365D] text-base group-hover:text-[#F6C344] transition-colors`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{record.label}</p>
                      <p className="text-gray-500 text-xs leading-relaxed mb-1.5">{record.desc}</p>
                      <span className="inline-flex items-center gap-1 text-[#1A365D] font-semibold text-xs group-hover:text-[#F6C344] transition-colors">
                        <i className="ri-external-link-line text-xs"></i>Get Records
                      </span>
                    </div>
                  </a>
                ))}
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-information-line text-amber-500 mr-1.5"></i>
                  <strong>Don&apos;t see your county?</strong> If the record you need was issued outside Levy County, visit <a href="https://www.vitalchek.com/" target="_blank" rel="noopener noreferrer" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">VitalChek.com</a> — the official online service for ordering vital records nationwide across all U.S. states and counties.
                </p>
              </div>
            </div>
          </div>

          {/* DMV */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-id-card-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Driver&apos;s License &amp; State ID</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Levy &amp; Alachua County Tax Collector — DMV Services</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">
                A valid government-issued photo ID is required for your passport application. If you need a new or renewed Florida driver&apos;s license or REAL ID, the Levy County Tax Collector in Bronson handles DMV services for Cedar Key residents.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">
                {dmvLocations.map((loc, i) => (
                  <div key={i} className={`rounded-lg p-4 border ${loc.featured ? "bg-amber-50 border-[#F6C344]/40" : "bg-[#F7F8FA] border-gray-200"}`}>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-map-pin-2-line text-[#1A365D] text-base"></i>
                      </div>
                      <div>
                        <p className="font-bold text-[#1A365D] text-xs leading-snug">{loc.name}</p>
                        <p className="text-gray-500 text-xs mt-1">{loc.address}</p>
                        <p className="text-gray-400 text-xs mt-0.5">{loc.hours}</p>
                        <p className="text-[#1A365D] text-xs font-medium mt-1.5 leading-snug">{loc.note}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex flex-wrap gap-4 mb-4">
                <a href="https://www.levyclerk.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors">
                  <i className="ri-external-link-line text-sm"></i>Levy County Tax Collector
                </a>
                <a href="https://www.flhsmv.gov/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors">
                  <i className="ri-external-link-line text-sm"></i>FLHSMV — Florida DMV
                </a>
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-calendar-check-line text-amber-500 mr-1.5"></i>
                  <strong>Appointment recommended</strong> — walk-in wait times can be long. Book your slot online at the Levy County Tax Collector website before visiting.
                </p>
              </div>
            </div>
          </div>

          {/* Airports */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-flight-takeoff-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Airports</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Airports Serving Cedar Key Travelers</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">
                Cedar Key is served by regional and major airports within driving distance. If your trip is coming up fast, make sure your passport is in hand well before your departure date.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
                {[
                  {
                    code: "GNV",
                    name: "Gainesville Regional Airport",
                    distance: "Primary regional airport — ~55 miles northeast of Cedar Key",
                    address: "3880 NE 39th Ave, Gainesville, FL 32609",
                    note: "American, Delta connections through Charlotte and Atlanta. Closest airport to Cedar Key.",
                    flightUrl: "https://www.gainesvilleairport.com/",
                    flightLabel: "GNV Airport Website",
                    featured: true,
                  },
                  {
                    code: "TPA",
                    name: "Tampa International Airport",
                    distance: "~120 miles south of Cedar Key",
                    address: "4100 George J Bean Pkwy, Tampa, FL 33607",
                    note: "Major hub with international flights. Southwest, Delta, American, United & many international carriers.",
                    flightUrl: "https://www.tampaairport.com/",
                    flightLabel: "TPA Airport Website",
                    featured: false,
                  },
                ].map((airport, i) => (
                  <div key={i} className={`rounded-lg p-4 border ${airport.featured ? "bg-amber-50 border-[#F6C344]/40" : "bg-[#F7F8FA] border-gray-200"}`}>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-[#1A365D] font-black text-xl leading-none">{airport.code}</span>
                      {airport.featured && (
                        <span className="text-xs font-bold text-amber-700 bg-amber-100 px-2 py-0.5 rounded-full">Closest</span>
                      )}
                    </div>
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{airport.name}</p>
                    <div className="flex items-center gap-1.5 text-xs text-[#F6C344] font-semibold mb-2">
                      <i className="ri-road-map-line"></i>
                      <span>{airport.distance}</span>
                    </div>
                    <p className="text-gray-500 text-xs leading-relaxed mb-1">{airport.address}</p>
                    <p className="text-gray-400 text-xs leading-relaxed mb-3">{airport.note}</p>
                    <a href={airport.flightUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors">
                      <i className="ri-external-link-line text-sm"></i>{airport.flightLabel}
                    </a>
                  </div>
                ))}
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-passport-line text-amber-500 mr-1.5"></i>
                  <strong>Passport required for all international flights.</strong> If your departure is within two weeks, standard processing won&apos;t make it in time — <a href="https://fastpassportcenter.com/checkout/" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">expedited processing through Fast Passport Center</a> is your most reliable option.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}